import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { useRescheduleState } from 'domains/direct-reschedule/useRescheduleProvider';
import { RescheduleDirectForm } from './form';
import { PageContainer } from '@expressable/syntax-ds';
import { DocumentTitle } from 'components/DocumentTitle';

export const Reschedule = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { clientId, rescheduleId } = useParams<{ clientId: string; rescheduleId: string }>();
  const { availableTimesQuery, rescheduleQuery } = useRescheduleState();

  if (!clientId || !rescheduleId) {
    throw new Error(t('errors.invalidClientState'));
  }

  if (rescheduleQuery.isLoading || availableTimesQuery.isLoading) {
    return (
      <>
        <DocumentTitle>{t('reschedule.pageTitle')}</DocumentTitle>
        <PageContainer variant="form">
          <RescheduleDirectForm loading />
        </PageContainer>
      </>
    );
  }

  if (rescheduleQuery.isError || availableTimesQuery.isError) {
    return <Navigate to="/reschedule/unavailable" />;
  }

  if (rescheduleQuery.isSuccess && availableTimesQuery.isSuccess && rescheduleQuery.data.status === 'active') {
    return (
      <>
        <DocumentTitle>{t('reschedule.pageTitle')}</DocumentTitle>
        <PageContainer variant="form">
          <RescheduleDirectForm />
        </PageContainer>
      </>
    );
  }

  if (rescheduleQuery.data?.status !== 'active') {
    return <Navigate to="/reschedule/expired" />;
  }

  return null;
};

export default Reschedule;
